
<div class="message" [innerHTML]="message">
</div>

<div class="action">
    <mat-icon (click)="closeSnackbar()" class="clickable">close</mat-icon>
</div>
